import { CalendarClock, FileText, Globe2 } from 'lucide-react'
import { scopeLabel } from '@/lib/siteHealth'
import { auditCoverageLabel, displayDate, pluralize } from './SiteHealthFormat'
import { EYEBROW_CLASS, PARTIAL_BADGE_CLASS } from './SiteHealthStyles'
import type { SiteHealthReportHeaderProps } from './siteHealthComponents.types'

export default function SiteHealthReportHeader({
  auditId,
  status,
  overview,
}: SiteHealthReportHeaderProps) {
  const completedDate = displayDate(status.completedAt)
  const partial = status.status === 'partial'
  const ScopeIcon = overview?.scope === 'single_page' ? FileText : Globe2

  return (
    <div>
      <p className={EYEBROW_CLASS}>Site Health report</p>
      <h1 className="mt-2 break-words text-3xl font-semibold tracking-tight">
        {overview?.url ?? `Audit ${auditId}`}
      </h1>
      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
        {overview && (
          <span className="inline-flex items-center gap-1.5">
            <ScopeIcon className="size-4" aria-hidden="true" />
            {scopeLabel(overview.scope)}
          </span>
        )}
        {completedDate && (
          <span className="inline-flex items-center gap-1.5">
            <CalendarClock className="size-4" aria-hidden="true" />
            Completed {completedDate}
          </span>
        )}
        <span className="tabular-nums">
          {pluralize(status.auditedPages, 'page')} audited
        </span>
        {partial && (
          <span className={PARTIAL_BADGE_CLASS}>
            Partial report · {auditCoverageLabel(status)}
          </span>
        )}
      </div>
    </div>
  )
}
